module.exports = __webpack_public_path__ + "static/img/2949_phase_function_Paper_PointsHejduk_Prediction.600ff30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2949_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Bnd6
// module chunks = 0